import Table from "@/common/components/Table";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { CompanyBillsTransformer } from "@/features/companies/services/companyBillsTransformer";
import { useCompanyGovernmentAllocationBills } from "@/features/privateCompanies/hooks/useCompanyGovernmentAllocationBills";
import { CompanyGovernmentAllocationData } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";
import { defaultColumns } from "@/features/privateCompanies/constants/companyBills.constants";

interface GovernmentAllocationBillsProps {
  companyGovernmentAllocation: CompanyGovernmentAllocationData;
}

const GovernmentAllocationBills = ({
  companyGovernmentAllocation,
}: GovernmentAllocationBillsProps) => {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: companyGovernmentAllocationBills,
    isLoading: companyGovernmentAllocationBillsIsLoading,
    meta,
  } = useCompanyGovernmentAllocationBills({
    governmentAllocationId: companyGovernmentAllocation.id,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: CompanyBillsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <Table
        className="min-h-[256px] max-h-[calc(100vh-432px)]"
        columns={defaultColumns}
        rows={companyGovernmentAllocationBills}
        hasPagination
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalCount={meta.total}
        totalPages={meta.total_pages}
        isLoadingData={companyGovernmentAllocationBillsIsLoading}
        loadingRows={2}
        rowEmptyValue="--"
      />
    </div>
  );
}

export default GovernmentAllocationBills;
